import { BROWSER_SESSION_ID_HEADER, getBrowserSessionId } from './browser-session-id';

import type { FrontendErrorRecord } from './frontend-error.model';

export interface FrontendErrorTransport {
  send(entry: FrontendErrorRecord): Promise<void>;
}

export class BrowserFrontendErrorTransport implements FrontendErrorTransport {
  constructor(private readonly endpoint = '/api/public/frontend-error') {}

  async send(entry: FrontendErrorRecord): Promise<void> {
    const payload = JSON.stringify(entry);

    if (typeof fetch !== 'function') {
      return;
    }

    await fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(getBrowserSessionId() ? { [BROWSER_SESSION_ID_HEADER]: getBrowserSessionId() } : {})
      },
      credentials: 'include',
      keepalive: true,
      body: payload
    }).catch(() => undefined);
  }
}
